// extracted by mini-css-extract-plugin
export default {"content":"CreateRouteModal_content__h1geK"};